<template>
  <div>
    <b-card>
      <div class="text-right mb-3">
        <router-link class="btn btn-primary" :to="{ name: 'bestof_objectives.create' }"><i class="fa fa-plus"></i>
          Criar</router-link>
        <exporter grid-ref="theGrid" :url="'campaignobjectives/exportobjectives'"></exporter>
      </div>

      <grid-filters grid-data="theGrid" :fields="gridFilters"></grid-filters>
      <Grid ref="theGrid" name="bestofObjectives" v-bind:url="url" v-bind:preload="preload" v-bind:columns="columns"
        :pageable="true" :filterable="true" :sortable="true" v-bind:schemaModelFields="schemaModelFields"></Grid>
    </b-card>
  </div>
</template>

<script>
import Grid from "@/components/Grid.vue";
import router from "@/router";
import lists from "@/components/States.js";

export default {
  name: "bestofObjectives",
  components: {
    Grid,
  },
  data() {
    return {
      gridFilters: [
        {
          field: "campaign_id",
          modal: "bestof-modal",
          foreign: "id",
          placeholder: "Campanha",
        },
        {
          field: "dealer_id",
          modal: "dealers-modal",
          foreign: "id",
          placeholder: "Distribuidor",
        },
        {
          field: "zone",
          modal: "zones-modal",
          foreign: "zone",
          placeholder: "Zona",
        },
      ],
      schemaModelFields: {
        created_at: {
          type: "date",
        },
        updated_at: {
          type: "date",
        },
        dealer_id: {
          type: "number",
        },
      },
      preload: [
        {
          api: "dealers/lst",
          field: "dealer_id",
        },
      ],
      url: "bestof/objectives",
      columns: [
        {
          template: this.getBtnTemplate,
          title: "Ações",
          width: "120px", 
        },
        {
          field: 'id',
          title: 'Id',
          width: '120px'
        },
        {
          field: "campaign_id",
          title: "Campanha",
          width: "220px",
        },
        {
          field: "dealer_id",
          title: "Distribuidor",
          width: "220px",
        },
        {
          field: "zone",
          title: "Zona",
          width: "120px",
        },
        {
          field: "value",
          title: "Valor",
          width: "120px",
        },
        {
          field: "operators",
          title: "Operadores",
          width: "120px",
        },
        {
          field: "quantity",
          title: "Quantidade",
          width: "120px",
        },
        {
          field: "created_at",
          title: "Criado em",
          format: "{0:dd/MM/yyyy HH:mm}",
          type: "date",
          width: "180px",
          filterable: {
            ui: function (element) {
              element.kendoDateTimePicker({
                format: "dd/MM/yyyy HH:mm",
              });
            },
          },
        },
        {
          field: "updated_at",
          title: "Atualizado em",
          format: "{0:dd/MM/yyyy HH:mm}",
          type: "date",
          width: "180px",
          filterable: {
            ui: function (element) {
              element.kendoDateTimePicker({
                format: "dd/MM/yyyy HH:mm",
              });
            },
          },
        },
      ],
    };
  },
  created() {
    // Vincula a função ao escopo global do browser para o Kendo conseguir aceder
    window.deleteObjectiveRow = this.deleteObjective;
  },
  destroyed() {
    // Limpa a função global para evitar vazamento de memória
    delete window.deleteObjectiveRow;
  },
  methods: {
    getBtnTemplate: function (item) {
      var route = router.resolve({
        name: "bestof_objectives.edit",
        params: {
          id: item.id,
        },
      });

      var html = "";

      if (this.$auth.check("bestof_objectives.edit")) {
        html += `
    <div style="width: 90px; margin: 0 auto;">
      <a href="${route.href}" 
         class="btn btn-primary btn-sm mb-2 d-block w-100 text-center">
        <i class="fa fa-pencil"></i> editar
      </a>

      <button type="button"
        class="btn btn-danger btn-sm d-block w-100 text-center"
        onclick="window.deleteObjectiveRow(${item.id})" style="margin-left: 0px !important;">
        <i class="fa fa-trash"></i> apagar
      </button>
    </div>
  `;
      }
      return html;
    },

    deleteObjective(id) {
      if (confirm("Tem a certeza que deseja eliminar este objetivo?")) {
        this.axios
          .delete(`${this.url}/${id}`) // Faz o DELETE para bestof/objectives/{id}
          .then(() => {
            this.$bvToast.toast("Objetivo eliminado com sucesso.", {
              variant: "success",
              solid: true,
            });
            // Força a Grid do Kendo a ler os dados atualizados da API
            const grid = this.$refs.theGrid.$refs.mygrid.kendoWidget();
            grid.dataSource.read();
          })
          .catch(() => {
            this.$bvToast.toast("Não foi possível eliminar o objetivo.", {
              variant: "danger",
              solid: true,
            });
          });
      }
    },

    exportGrid() {
      this.exporting = true;
      const grid = this.$refs.campaignResultsGrid.$refs.mygrid.kendoWidget();
      const filters = grid.getOptions().dataSource.filter;

      this.axios
        .post("campaignobjectives/exportobjectives", { filter: filters })
        .then((response) => {
          if (response.data && response.data.url) {
            window.open(response.data.url, "_blank");
          } else {
            this.$bvToast.toast("Falha ao gerar o arquivo.", {
              variant: "danger",
              solid: true,
            });
          }
          this.exporting = false;
        })
        .catch((error) => {
          console.error(error);
          this.$bvToast.toast("Houve um erro ao exportar", {
            autoHideDelay: 5000,
            variant: "danger",
            solid: true,
          });
          this.exporting = false;
        });
    },
  },
};
</script>